import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dark%20abstract%20digital%20security%20landscape%20with%20glowing%20circuit%20lines%20and%20shield%20symbols%20representing%20cybersecurity%20and%20privacy%20protection%2C%20warm%20amber%20and%20green%20accents%20on%20dark%20background%2C%20modern%20minimalist%20tech%20aesthetic%2C%20cinematic%20composition%20with%20dramatic%20lighting&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="暗网91安全指南 - 深网安全知识平台"
        title="暗网91安全指南首页背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-3xl mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-300 text-sm mb-6 backdrop-blur-sm">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-check-line"></i>
            </span>
            <span>暗网91官方安全指南 · 2026年8月更新</span>
          </div>
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4 leading-tight">
            暗网91官方入口 · 深度解析与安全指南
          </h1>
          <p className="text-sm md:text-base text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            全面解析暗网91的访问方式、安全风险、真实评测及合规使用建议，帮助您了解暗网运作机制，规避潜在威胁，保护个人隐私与数据安全。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/access-tutorial"
              className="px-6 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-sm"
            >
              <i className="ri-global-line mr-2"></i>
              查看访问教程
            </Link>
            <Link
              to="/category/security-guide"
              className="px-6 py-3 bg-white/10 text-white font-medium rounded-md border border-white/20 hover:bg-white/20 transition-all duration-200 whitespace-nowrap text-sm backdrop-blur-sm"
            >
              <i className="ri-shield-check-line mr-2"></i>
              浏览安全指南
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}